import { translations } from './cms.cache';

export const cms = {
  read() {
    return {
      translations: translations(),
    };
  },
};
